import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Key } from "@phosphor-icons/react";

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (next !== confirm) return toast.error("Passwords do not match");
    if (next.length < 8) return toast.error("New password must be at least 8 characters");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  }

  return (
    <div>
      <h1 className="font-heading font-black text-3xl">Change Password</h1>
      <form onSubmit={submit} className="mt-5 bg-white border border-neutral-200 rounded-2xl p-5 max-w-md space-y-3" data-testid="cp-form">
        <div>
          <label className="text-xs font-bold uppercase tracking-widest text-neutral-500">Current Password</label>
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1 w-full px-3 py-2 rounded-md border border-neutral-300 text-sm" data-testid="cp-current" required />
        </div>
        <div>
          <label className="text-xs font-bold uppercase tracking-widest text-neutral-500">New Password</label>
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} className="mt-1 w-full px-3 py-2 rounded-md border border-neutral-300 text-sm" data-testid="cp-new" required minLength={8} />
        </div>
        <div>
          <label className="text-xs font-bold uppercase tracking-widest text-neutral-500">Confirm New Password</label>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1 w-full px-3 py-2 rounded-md border border-neutral-300 text-sm" data-testid="cp-confirm" required minLength={8} />
        </div>
        <button disabled={busy} className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-neutral-900 text-white font-semibold hover:bg-neutral-800 disabled:opacity-60" data-testid="cp-submit">
          <Key size={14} weight="bold" /> {busy ? "Saving…" : "Update Password"}
        </button>
      </form>
    </div>
  );
}
